import * as React from 'react';
import { PortalContext } from '../../../../context/PortalContext';
import { Environment } from '../../../../enviroment';
import { BonusStatus, BonusTypeEnum, Bonus, CarouselModeEnum } from '@esportal/portal-service';
import { BonusCard } from './bonus-card';
import { useTrackingManager } from '../../../../tracking/useTrackingManager';
import { formatOwnership } from '../../../../tracking/trackingHelper';
import { vwDataRedirect } from '../../../../helpers/BonuesHelper';

export const BonusCtr: React.FC<{
	bonus: Bonus;
	carouselMode: CarouselModeEnum;
	showButton?: boolean;
	bonusType: BonusTypeEnum;
	setBonusPopupData: React.Dispatch<React.SetStateAction<Bonus | undefined>>;
	setIsBonusPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ bonus, carouselMode, showButton = true, bonusType, setBonusPopupData, setIsBonusPopupVisible }) => {
	const { navigationService, userInteractionService, portalService } = React.useContext(PortalContext);
	const trackingManager = useTrackingManager();

	const shouldDisplayGetButton = (bonus: Bonus): boolean => {
		let result = true;

		switch (bonus.status) {
			case BonusStatus.ENJOYED:
			case BonusStatus.NO_EXPIRATION:
			case BonusStatus.TO_ENJOY:
			case BonusStatus.TO_ENJOY_SOON:
			case BonusStatus.BBO_TO_REDEEM:
			case BonusStatus.BBO_TO_REDEEM_SOON:
			case BonusStatus.BBO_REDEEMED:
			case BonusStatus.BBO_REDEEMED_SOON:
				result = true;
				break;
			case BonusStatus.EXPIRED:
				result = false;
				break;
		}
		return result;
	};

	const handleClickBonus = () => {
		const vehicle = bonus?.frame ? portalService.getVehicleByFrame(bonus.frame).getValue() : null;
		trackingManager.trackClubVWButtonClick(
			'My Bonus',
			{ contentId: `Bonus type ${bonusType}: ${bonus.title}` },
			{ vehicle: vehicle ? formatOwnership([vehicle]) : [] },
		);

		if (bonus.type == 'vwdata') {
			if (bonus.isLayer) {
				setBonusPopupData(bonus);
				setIsBonusPopupVisible(true);
			} else {
				vwDataRedirect(bonus, navigationService, userInteractionService);
			}
		} else if (bonus.type == 'salesforce') {
			const environmentPath = Environment.getInstance().bonusDetailPageId as string;
			const search = window.location.search;
			const target = navigationService.navigateTo(environmentPath, {});
			if (target) {
				target.push();
				const href = target.createHref();
				addParamToUrl(href, bonus.id, search);
			} else {
				console.log('detail page not created');
			}
		} else {
			console.error('bonus type error');
		}
	};

	const addParamToUrl = (href: string, param: string, search: string) => {
		const newSearchParams = new URLSearchParams(search);
		newSearchParams.append('bonus-id', param);
		window.history.replaceState(null, '', href + `?${newSearchParams.toString()}`);
	};

	return (
		<BonusCard
			bonus={bonus}
			shouldDisplayGetButton={shouldDisplayGetButton(bonus)}
			carouselMode={carouselMode}
			handleClickBonus={handleClickBonus}
			showButton={showButton}
		/>
	);
};
